import { animateItemsIn } from './modules/animate-items-in.js';

/**
 * Blog smart rows AJAX logic.
 */
export const initBlogAjax = () => {
    const grid = document.querySelector('.js-blog-grid');
    const loadBtn = document.querySelector('.js-load-blog-posts');
    if (!grid || !loadBtn) return;

    const setLoadButtonVisible = (isVisible) => {
        const wrapper = loadBtn.closest('.blog-page__load-more');
        loadBtn.hidden = !isVisible;
        if (wrapper) wrapper.hidden = !isVisible;
    };

    const getTotalPosts = () => parseInt(loadBtn.dataset.total || '0', 10) || 0;
    const getLoadedPosts = () => grid.querySelectorAll('.blog-card').length;
    const getLoadCount = () => Math.max(1, parseInt(loadBtn.dataset.loadCount || '2', 10) || 2);
    const updateLoadButton = () => setLoadButtonVisible(getLoadedPosts() < getTotalPosts());

    loadBtn.addEventListener('click', async (event) => {
        event.preventDefault();

        const offset = getLoadedPosts();
        if (offset >= getTotalPosts()) {
            setLoadButtonVisible(false);
            return;
        }

        loadBtn.classList.add('loading');
        loadBtn.disabled = true;

        const formData = new FormData();
        formData.append('action', 'load_more_blog_posts');
        formData.append('offset', offset);
        formData.append('load_count', getLoadCount());
        formData.append('nonce', window.jctc_vars?.nonce || '');

        try {
            const response = await fetch(window.jctc_vars.ajax_url, {
                method: 'POST',
                body: formData,
            });
            const result = await response.json();

            if (result.success) {
                if (result.data.html) {
                    const countBefore = getLoadedPosts();
                    grid.insertAdjacentHTML('beforeend', result.data.html);
                    animateItemsIn(
                        Array.from(grid.querySelectorAll('.blog-card')).slice(countBefore)
                    );
                }

                loadBtn.dataset.total = result.data.total_posts || loadBtn.dataset.total || '0';
                updateLoadButton();
            }
        } catch (error) {
            console.error('Blog AJAX Load Error:', error);
        } finally {
            loadBtn.classList.remove('loading');
            loadBtn.disabled = false;
        }
    });

    updateLoadButton();
};
